import React from 'react';
import { priceFormat } from '../../../../util';
import { ResultsColumn, ResultsColumnHeader, Row, HeaderRow, SubTitleText, Spreadsheet } from '../DTInfoWidget.styles';
import { getItemNameAndQuantity } from '../helpers';
import * as toolSelectors from '../../../../selectors/tools';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

const DTCanceledItemDetailsWidget = () => {
  const canceledItems = useSelector(toolSelectors.getCanceledItems);
  const orderingSystem = useSelector(toolSelectors.getOrderingSystem);

  if (!isEmpty(canceledItems)) {
    return (
      <Spreadsheet className="fs-block">
        <SubTitleText>CANCELED ITEMS</SubTitleText>
        <HeaderRow>
          <ResultsColumnHeader>ITEM</ResultsColumnHeader>
          <ResultsColumnHeader>PRICE</ResultsColumnHeader>
        </HeaderRow>
        {canceledItems.map((item) => (
          <Row key={JSON.stringify(item)} className="fs-block">
            <ResultsColumn>{getItemNameAndQuantity(item, orderingSystem)}</ResultsColumn>
            <ResultsColumn>{priceFormat(item.price)}</ResultsColumn>
          </Row>
        ))}
      </Spreadsheet>
    );
  }

  return null;
};
export default DTCanceledItemDetailsWidget;
